export default "<!--ui modal declaration-->";